import { createSelector } from 'reselect';
import {
    getDestinationRoutes,
    getExternalDataRoutes,
    getListenerRoutes,
} from '../helpers/cms/subscriber';
import { SUBSCRIBER_PATH } from '../constants';
import EventReporting from '../components/cms/subscriber/event-reporting/EventReporting';
import { getCustomExternalObjectReport, getExternalObjectReport } from '../actions/subscriber';

const selectRoutes = (state) => state.subscriber.routes ?? [];
const selectSecondId = (state) => state.subscriber.activeAccount?.secondId;
const selectEventReportingEnabled = (state) => state.subscriber.activeAccount?.packageEventReporting;
const selectCustomSources = (state) => state.subscriber.accountExternalData?.customSources;
const selectActiveListeners = (state) => state.subscriber.activeListeners;
const selectActiveDestinations = (state) => state.subscriber.activeDestinations;

const selectExternalObjectReport = (state) => state.subscriber.externalObjectReport;
const selectCustomExternalObjectReport = (state) => state.subscriber.customExternalObjectReport;

const EVENT_REPORTING_ROUTES = [
    {
        path: SUBSCRIBER_PATH.GLOBAL_REPORTING,
        name: 'Global Reporting',
        component: EventReporting,
    },
    {
        path: SUBSCRIBER_PATH.INSIGHTS,
        name: 'Analytics',
        component: EventReporting,
    },
];

export const selectSubscriberRoutes = createSelector(
    [
        selectRoutes,
        selectSecondId,
        selectEventReportingEnabled,
        selectCustomSources,
        selectActiveListeners,
        selectActiveDestinations,
        selectExternalObjectReport,
        selectCustomExternalObjectReport,
    ],
    (
        baseRoutes,
        secondId,
        eventReportingEnabled,
        customSources,
        activeListeners,
        activeDestinations,
        externalObjectReport,
        customExternalObjectReport
    ) => {
        const routes = [
            ...baseRoutes,
            ...getListenerRoutes(activeListeners, [], secondId),
            ...getDestinationRoutes(activeDestinations, secondId),
            ...getExternalDataRoutes(customSources, secondId),
            ...getExternalObjectReport({ externalObjectReport, secondId }),
            ...getCustomExternalObjectReport({ customExternalObjectReport, secondId }),
        ];

        if (eventReportingEnabled) {
            const existingPaths = new Set(routes.map((r) => r.path));

            EVENT_REPORTING_ROUTES.forEach((route) => {
                if (!existingPaths.has(route.path)) {
                    routes.push(route);
                }
            });
        }

        return routes;
    }
);
